
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";
import { successAlert } from "../../../components/alert/defaultAlert";
import axiosInstance from "../../../../services/AxiosInstance";
import LockOpenIcon from "../../../components/Icon/LockOpenIcon";
import { convertStringToStringDouble } from "../../../../utils/ConverterUtils";
import { useNavigate } from "react-router-dom";

const CashNew = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        openingBalance: Yup.string().required(t('cash_flow.validation.required.initial_balance')),
        branch: Yup.object().required(t('validation.required.branch')).nullable(),
        obs: Yup.string().optional()
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            openingBalance: 0,
            branch: null,
            obs: ''
        },
        validationSchema: formSchema,
        onSubmit: (values) => {
            
            let payload = {
                openingBalance: convertStringToStringDouble(values.openingBalance),
                branch: {
                    id: values.branch.value
                },
                obs: values.obs
            }

            // Aciona a api
            axiosInstance.post(Api.cash_flow.cash, payload)
                .then(() => {
                    successAlert(t('message.operation_successfully'), () => {
                        navigate(MenuConfig.cash_flow.cash_registers.route);
                    });
                })
                .catch(error => ApiError(error))
                .finally(() => {
                    // Deixa habilitado o botão de submit.
                    formik.setSubmitting(false);
                });
        },
    });

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('cash_flow.label')}
                childMenu={t('cash_flow.cash_registers')}
                activeMenu={t('new')}
                child={
                    <Form formik={formik} />}
                path={"/cash-flow/cashes"}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.cash_flow.cash_registers.route}
                saveButtonText={t('cash_flow.open_cash_register')}
                saveButtonIcon={<LockOpenIcon/>}
            />
        </>
    );
}

export default CashNew;
